import { Tool } from '../../types';

export const cloudTools: Tool[] = [
  {
    id: 'aws',
    name: 'Amazon Web Services',
    category: 'Cloud Infrastructure',
    description: 'Comprehensive cloud computing platform',
    pricing: ['low', 'medium', 'high'],
    features: ['scalability', 'security', 'integrations'],
    bestFor: ['startup'],
    compatibleWith: ['saas', 'mobile-app'],
    goals: ['streamline-operations', 'scalability'],
    industries: ['technology'],
    website: 'https://aws.amazon.com',
    imageUrl: 'https://logo.clearbit.com/aws.amazon.com',
    idealStages: ['launching', 'growing', 'scaling'],
    technicalLevel: ['intermediate', 'advanced'],
    minTeamSize: 'solo'
  },
  {
    id: 'google-cloud',
    name: 'Google Cloud Platform',
    category: 'Cloud Infrastructure',
    description: 'Cloud computing services and infrastructure',
    pricing: ['low', 'medium', 'high'],
    features: ['scalability', 'integrations', 'security'],
    bestFor: ['startup'],
    compatibleWith: ['saas', 'mobile-app'],
    goals: ['streamline-operations', 'scalability'],
    industries: ['technology'],
    website: 'https://cloud.google.com',
    imageUrl: 'https://logo.clearbit.com/google.com',
    idealStages: ['launching', 'growing', 'scaling'],
    technicalLevel: ['intermediate', 'advanced'],
    minTeamSize: 'solo'
  },
  {
    id: 'digitalocean',
    name: 'DigitalOcean',
    category: 'Cloud Infrastructure',
    description: 'Simple cloud computing for developers',
    pricing: ['low', 'medium'],
    features: ['ease-of-use', 'scalability', 'security'],
    bestFor: ['startup'],
    compatibleWith: ['saas', 'mobile-app'],
    goals: ['streamline-operations', 'reduce-costs'],
    industries: ['technology'],
    website: 'https://www.digitalocean.com',
    imageUrl: 'https://logo.clearbit.com/digitalocean.com',
    idealStages: ['launching', 'growing'],
    technicalLevel: ['intermediate', 'advanced'],
    minTeamSize: 'solo'
  }
];